"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterReporterMetadata = void 0;
/**
 * Recursively filter reporter metadata.
 * @param metadata Deep Metadata to filter.
 * @param reporter Reporter with filter config.
 * @param prefix Prefix for recusring nested metadata.
 * @returns Filtered metadata.
 */
function filterReporterMetadata(metadata, reporter, prefix) {
    const ignorePatterns = reporter.ignoreMetadataPatterns;
    // No metadata, or no patterns.
    if (metadata === undefined || !ignorePatterns) {
        return metadata;
    }
    const entries = Object.entries(metadata);
    return Object.fromEntries(entries
        .filter(([key]) => {
        const fullKey = prefix ? prefix + key : key;
        return !ignorePatterns.some((pattern) => typeof pattern === 'string' ? pattern === fullKey : pattern.test(fullKey));
    })
        .map(([key, value]) => {
        if (typeof value === 'object' && value !== null) {
            const fullKey = prefix ? prefix + key : key;
            return [key, filterReporterMetadata(value, reporter, `${fullKey}.`)];
        }
        return [key, value];
    }));
}
exports.filterReporterMetadata = filterReporterMetadata;
//# sourceMappingURL=utils.js.map